<template>
  <div class="home">
    <div class="columns is-mobile is-multiline">
      <div class="column is-full-mobile is-full-desktop">
        <!-- <CategoryCard category_name="校园纯色"></CategoryCard> -->
        <ul>
          <li v-for="(book, index) in books" :key="book.id">
            <BookCard :book_name="book"></BookCard>
            <GuanggaoCard adname="广告1" v-if="Math.round((index+1)%ad_interval)==0"></GuanggaoCard>
          </li>
        </ul>
      </div>
    </div>
    <Footer></Footer>
    <!-- <footer class="footer">
      <div class="content has-text-centered">
        <p>
          <strong>小黄书</strong> by
          <a href="https://jgthms.com">xiaohuangshu</a>
        </p>
      </div>
    </footer>-->
  </div>
</template>

<script>
// @ is an alias to /src
// import CategoryCard from "@/components/CategoryCard.vue";
import GuanggaoCard from "@/components/AdCard.vue";
import BookCard from "@/components/BookCard.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "CategoryList",
  components: {
    // CategoryCard,
    GuanggaoCard,
    BookCard,
    Footer
  },
  data() {
    return {
      ad_interval: 5,
      books: [
        "小说1",
        "小说2",
        "小说3",
        "小说4",
        "小说1",
        "小说2",
        "小说3",
        "小说4",
        "小说3",
        "小说4",
        "小说1",
        "小说2",
        "小说3",
        "小说4"
      ]
    };
  }
};
</script>
